import Rails from '@rails/ujs'
import Turbolinks from 'turbolinks'
import * as ActiveStorage from '@rails/activestorage'
import 'vue-select/dist/vue-select.css';
import 'jquery'
import 'bootstrap'
import 'flatpickr/dist/flatpickr.css';

global.$ = require('jquery');

window.stdoutText = ''

Rails.start()
Turbolinks.start()
ActiveStorage.start()

const bindToastr = () => {
  const defaultOptions = { positionClass: 'toast-top-center mt-5 pt-3', timeOut: "5000", closeButton: false }

  $.alertSuccess = (message, options = {}) => {
    return toastr.success(message, '', $.extend(defaultOptions, options))
  }

  $.alertError = (message, options = {}) => {
    return toastr.error(message, '', $.extend(defaultOptions, options))
  };

  $.alertWarning = (message, options = {}) => {
    return toastr.warning(message, '', $.extend(defaultOptions, options))
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const toast = document.querySelector("#toast");
  bindToastr();
  if (toast) {
    setTimeout(() => {
      toast.remove();
    }, 3000);
  }
});

